<template>
  <div>
    <h3 class="h-title">服务要素信息</h3>
    <el-form class="e-form f-b" ref="cForm2" :model="cForm2" label-width="180px"  label-position="left" :rules="cRules">
      <el-form-item label="选择律所" prop="lawFirmObj">
        <el-select v-model="cForm2.lawFirmObj" @change="setLawFirm" value-key="deptName" placeholder="请选择律所" style="width: 100%">
          <el-option
            v-for="dict in lawOptions"
            :key="dict.nodeId"
            :label="dict.nodeName"
            :value="dict"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="存储类型" prop="saveType">
        <el-select v-model="cForm2.saveType" placeholder="请选择存储类型" style="width: 100%">
          <el-option
            v-for="dict in typeOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合同名称" prop="mainContractName">
        <el-input v-model="cForm2.mainContractName" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="合同编号" prop="mainContractNo">
        <el-input v-model="cForm2.mainContractNo" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="合同期限" prop="mainContractPeriod">
          <el-date-picker  style="width: 100%"
              format="yyyy-MM-dd" 
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              v-model="cForm2.mainContractPeriod"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item class="w-70" label="合同金额(万元)" prop="mainContractAmount" >
        <el-input-number v-model="cForm2.mainContractAmount" controls-position="right" @blur="conversion('mainContractAmount')" :precision="4" :step="0.1" :min="0" placeholder="请输入数字，小数点后4位" style="width: 100%"></el-input-number>
      </el-form-item> 
      <el-form-item label="合同签约主体1名称" prop="mainContractSignName1">
        <el-input v-model="cForm2.mainContractSignName1"  :maxlength="50" placeholder="请输入<=50文字" />
        <span class="tag">注：请填写前置处置措施保障的债权人名称</span>
      </el-form-item>
      
      <el-form-item label="合同签约主体2名称" prop="mainContractSignName2">
        <el-input v-model="cForm2.mainContractSignName2" :maxlength="50" placeholder="请输入<=50文字" />
        <span class="tag">注：请填写前置处置措施保障的债务人名称</span>
      </el-form-item>
      
      <div v-for="index in mainContractSignNum" :key="index">
        <el-form-item :label="`合同签约主体${index+2}名称`" :prop="`mainContractSignName${index+2}`" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm2['mainContractSignName'+(index+2)]" :maxlength="50" placeholder="请输入<=50文字" style="width: 80%" />
          <el-button class="s-but" type="orange" @click="delMainNum(index)" style="width: 15%; margin: 0 0 0 5%">删除</el-button>
        </el-form-item>
      </div>
      
      <el-button v-show="mainContractSignNum<8" class="s-but" style="margin-top:5px" icon="el-icon-plus" type="orange" @click="addMainNum">其他签约主体</el-button>

      <el-form-item label="前置处置标的资产名称" prop="assetNameObj" class="label-right">
        <el-checkbox-group v-model="cForm2.assetNameObj">
          <div class="checkbox-item">
            <el-checkbox class="checkbox-label" label="stock">股权</el-checkbox>
            <el-form-item label="说明：" prop="stockRemark" label-width="80px" style="width: 100%" :rules="[{required: isCheck('stock', 'stockRemark'),message:'请输入',trigger:'blur'}]">
              <el-input v-model="cForm2.stockRemark" :maxlength="30" placeholder="请输入<=30文字" />
            </el-form-item>            
          </div>
          <div class="checkbox-item">
            <el-checkbox class="checkbox-label" label="realAsset">实物资产</el-checkbox>
            <el-form-item label="说明：" prop="realAssetRemark" label-width="80px" style="width: 100%" :rules="[{required: isCheck('realAsset', 'realAssetRemark'),message:'请输入',trigger:'blur'}]">
              <el-input v-model="cForm2.realAssetRemark" :maxlength="30" placeholder="请输入<=30文字" />
            </el-form-item> 
          </div>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="前置处置标的资产所有人" prop="assetOwner" class="label-right">
        <el-input v-model="cForm2.assetOwner" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="前置处置受托机构" prop="trusteeInstitution" class="label-right">
        <el-input v-model="cForm2.trusteeInstitution" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="存证说明" class="label-right">
        合同签约主体已委托前置处置受托机构对标的资产进行前置处置，并将处置价款作为债务人清偿债务的保障。
      </el-form-item>
    </el-form>
    <div class="cenrer">			
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
export default {
  name: "step1",
  props: ["active", "id"],
  data() {
    return {
      headers: {},
      action: '',
      file: '',
      butLoading: false,
      cFileList: [],
      cForm2: {
        assetNameObj: []
      },
      // 表单校验
      cRules: {
        lawFirmObj: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        saveType: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        mainContractName: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractNo: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractPeriod: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        mainContractAmount: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractSignName1: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractSignName2: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        assetNameObj: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        assetOwner: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        trusteeInstitution: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
      },
      lawOptions: [],
      typeOptions: [],
      lawFirmOptions: [],
      mainContractSignNum: 0,
      subContractSignNum: 0,
      mainContractSignList: [],
      subContractSignList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 1000,
        businessType:'2', 
        status: '0'
      },
    }
  },
  watch: {
    active(newVal) {
        if(newVal == 1) {
          window.scrollTo(0,0);
          this.cForm2 = JSON.parse(sessionStorage.setpForm);
          this.getLawFirm()
          this.setCForm2()
        } 
      }
  },
  mounted(){
    this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
    
    if(this.id) {
      this.getDetial();
    }else {
      this.getLawFirm()
      this.setCForm2()
    }
  },
  methods: { 
    isCheck(val, name){
      if(this.cForm2.assetNameObj.indexOf(val) >= 0) {
        return true
      }else{
        this.$nextTick(()=>{
          this.$refs['cForm2'].clearValidate(name);
        })
        return false
      }
    },
    setCForm2(){
        if(this.cForm2.lawFirmName){
          this.$set(this.cForm2, 'lawFirmObj', {
            deptName: this.cForm2.lawFirmName,
            deptId: this.cForm2.lawFirm
          })
        }
        if(this.cForm2.mainContractPeriodStart){
          this.$set(this.cForm2, 'mainContractPeriod', [this.cForm2.mainContractPeriodStart, this.cForm2.mainContractPeriodEnd])       
        }

        // 标的资产名称
        let assetNameObj = []
        this.cForm2.assetName = JSON.parse(this.cForm2.assetName)
        this.cForm2.assetName.forEach(item => {
          for (let key in item){
            if(key != 'remark'){
              assetNameObj.push(key)
              this.$set(this.cForm2, key+'Remark', item.remark)
            }
          }
        })
        this.$set(this.cForm2, 'assetNameObj', assetNameObj)

        // 金额
        if(this.cForm2.mainContractAmount == null){
          delete this.cForm2.mainContractAmount
        }
        if(this.cForm2.subContractAmount == null){
          delete this.cForm2.subContractAmount
        }

        // 主体个数
        for(let j=10; j>2; j--){
          if(this.cForm2['mainContractSignName'+(j)]){
            this.mainContractSignNum = j-2;
            return
          }
        }
    },
    //获取详情
    getDetial() {
        this.$api.api.preDetail(this.id).then(res => {
            if(res.code==200){
                this.cForm2 = Object.assign({}, res.data); 	
                this.getLawFirm()
                this.setCForm2()
            }else {
                this.$message.error(res.msg);
            }    
        });      
    },
    conversion(name) {
      this.cForm2[name+'Rmb'] = this.smalltoBIG(this.cForm2[name]*10000);
    },
    /** 数字金额大写转换(可以处理整数,小数,负数) */    
    smalltoBIG(n){    
      let fraction = ['角', '分'];    
      let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];    
      let unit = [ ['元', '万', '亿'], ['', '拾', '佰', '仟']  ];    
      let head = n < 0? '欠': '';    
      n = Math.abs(n);    
    
      let s = '';    
    
      for (let i = 0; i < fraction.length; i++)     
      {    
          s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');    
      }    
      s = s || '整';    
      n = Math.floor(n);    
    
      for (let i = 0; i < unit[0].length && n > 0; i++)     
      {    
          let p = '';    
          for (let j = 0; j < unit[1].length && n > 0; j++)     
          {    
              p = digit[n % 10] + unit[1][j] + p;    
              n = Math.floor(n / 10);    
          }    
          s = p.replace(/(零.)*零$/, '').replace(/^$/, '零')  + unit[0][i] + s;    
      }    
      return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');    
    },
    addMainNum(){
      this.mainContractSignNum++
    },
    delMainNum(i){
      let mainArry = []
      for(let j=0; j<this.mainContractSignNum; j++ ){
        mainArry[j] = this.cForm2['mainContractSignName'+(j+3)]
      }
      this.mainContractSignNum--
      mainArry.splice(i-1, 1)

      for(let m=0; m<this.mainContractSignNum; m++ ){
        this.cForm2['mainContractSignName'+(m+3)] = mainArry[m]
      }
      this.cForm2['mainContractSignName'+(this.mainContractSignNum+3)] = ""
    },
    addSubNum(){
      this.subContractSignNum++
    },
    delSubNum(i){
      let subArry = []
      for(let j=0; j<this.subContractSignNum; j++ ){
        subArry[j] = this.cForm2['subContractSignName'+(j+3)]
      }
      this.subContractSignNum--
      subArry.splice(i-1, 1)

      for(let m=0; m<this.subContractSignNum; m++ ){
        this.cForm2['subContractSignName'+(m+3)] = subArry[m]
      }
      
      this.cForm2['subContractSignName'+(this.subContractSignNum+3)] = ""
    },
    setLawFirm(obj){
      this.cForm2.lawFirmName = obj.nodeName
      this.cForm2.lawFirm = obj.nodeId
    },
    getLawFirm(){
      console.info("11")
      this.$api.api.getDicts("pre_save_type").then(response => {
          this.typeOptions = response.data;
      });
      this.$api.api.nodeList({...this.queryParams,nodeType:'2'}).then(response => {
        if(response.code == 200){
          this.lawOptions = response.rows   
          console.info(this.cForm2.lawFirmName)       
          if(this.cForm2.lawFirmName){
            this.$set(this.cForm2, 'lawFirmObj', {
              nodeName: this.cForm2.lawFirmName,
              nodeId: this.cForm2.lawFirm
            })
          }
        }else {
          this.$message.error(response.msg);
        }      
      });
    },
    prev() {
      sessionStorage.setpForm = JSON.stringify(this.cForm2);
      this.$emit('prev')
    },
    cSubmitForm(type){
      if(this.cForm2.mainContractPeriod){
        this.cForm2.mainContractPeriodStart = this.cForm2.mainContractPeriod[0]
        this.cForm2.mainContractPeriodEnd = this.cForm2.mainContractPeriod[1]
      }
      // 标的资产名称
      this.cForm2.assetName = []
      this.cForm2.assetNameObj.forEach((item, i) => {
        this.cForm2.assetName[i] = {}
        this.cForm2.assetName[i][item] = true;
        this.cForm2.assetName[i]['remark'] = this.cForm2[item+'Remark']
      })
      this.cForm2.assetName = JSON.stringify(this.cForm2.assetName)

      // 用户经理
      this.cForm2.userManager = sessionStorage.applyCustomerName
      this.cForm2.userManagerPhone = sessionStorage.applyCustomerContact
      this.cForm2.userManagerAccount = sessionStorage.applyCustomerAccount
      this.cForm2.submitName = sessionStorage.projectName

      // 存证说明
      this.cForm2.contractMark = '合同签约主体已委托前置处置受托机构对标的资产进行前置处置，并将处置价款作为债务人清偿债务的保障。'

      if(type == '0'){                  
        this.butLoading = true;
        this.cForm2.status = '0'
        this.$api.api.addAndUpd(JSON.stringify(this.cForm2)).then(response => {
          this.butLoading = false;
          if(response.code == 200){
            sessionStorage.removeItem("setpForm")
            this.$message.success("保存成功");
            this.$router.go(-1);
          }     
        });
        
      }else{
        this.$refs["cForm2"].validate(valid => {
          if (valid) {
            sessionStorage.setpForm = JSON.stringify(this.cForm2);
            this.$emit('next');
          }
        }) 
      }  
    },
    handleError(err, file, fileList){
      this.$message.error(file.name + "文件上传失败");
    },
    beforeUpload(file) { 	
      const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
      
      if(!isLt2M) {
        this.$message.error('上传文件大小不能超过 80MB！');
      }
      return isLt2M
    },
    cUpload(response, file, list){
        if(response.code == 200){
          this.cForm2.fileName = file.name
          this.cForm2.fileHash = response.data.hash
          this.$set(this.cForm2, 'fileUrl', response.data.path)
        }else{
            this.$message.error(file.name + "文件上传失败");
            this.cForm2.fileName = ''
            this.cForm2.fileHash = ''
            this.cForm2.fileUrl = ''
            this.cFileList = []
        }              
    },
    handleCRemove(file, fileList) {
      this.cForm2.fileName = ''
      this.cForm2.fileHash = ''
      this.cForm2.fileUrl = ''
      this.cFileList = []
    },
  }
}
</script>
<style>
.checkbox-item{display: flex; margin-bottom: 15px;}
.checkbox-item .checkbox-label{display: inline-block; width: 120px;}
.label-right .el-form-item__label{text-align: right;}
</style>
